<template lang="pug">
draggable.fb-list(
    :class="{ 'is-empty': !list.length }"
    :data-empty-text="$t('Drop elements here')"
    :list="list"
    :group="{ name: 'fb-elements' }"
    :disabled="!edit"
    handle=".fb-handle"
    :animation="150"
    :options="{ forceFallback: true, fallbackOnBody: true, emptyInsertThreshold: 40 }"
    ghost-class="fb-ghost"
    drag-class="fb-drag"
    @change="$emit('change')"
    @end="$emit('change')"
)
    .fb-block(v-for="block in list" :key="block.id")
        form-builder-columns(
            v-if="block.type === 'columns'"
            :block="block"
            :selected-id="selectedId"
            :edit="edit"
            :options="options"
            @change="$emit('change')"
            @select="$emit('select', $event)"
            @delete="$emit('delete', $event)"
        )
        form-builder-element(
            v-else
            :element="block"
            :edit="edit"
            :selected="block.id === selectedId"
            :options="options"
            @select="$emit('select', $event)"
            @delete="$emit('delete', $event)"
            @change="$emit('change')"
        )
</template>

<i18n>
{
    "en": { "Drop elements here": "Drop elements here" },
    "de": { "Drop elements here": "Elemente hierher ziehen" }
}
</i18n>

<script>
import draggable from 'vuedraggable'
import FormBuilderElement from './FormBuilderElement'
import FormBuilderColumns from './FormBuilderColumns'

export default {
    name: 'FormBuilderList',
    components: { draggable, FormBuilderElement, FormBuilderColumns },
    props: {
        // the root block array — mutated in place by vuedraggable
        list: { type: Array, default: () => [] },
        selectedId: { type: String, default: null },
        edit: { type: Boolean, default: true },
        options: { type: Object, default: () => ({}) },
    },
}
</script>

<style lang="sass" scoped>
.fb-list
    display: flex
    flex-direction: column
    gap: .6rem
    min-height: 120px
    padding: .65rem
    background: #f5f7fa
    border: 1px dashed #d3d7de
    border-radius: 8px
    &.is-empty
        align-items: center
        justify-content: center
        &::after
            content: attr(data-empty-text)
            color: #b4b9c2
            font-size: .82rem
            pointer-events: none
.fb-block
    width: 100%
.fb-ghost
    opacity: 1
    border: 1px dashed $--color-primary !important
    border-radius: 6px
    background: rgba($--color-primary, .08)
    ::v-deep > *
        visibility: hidden
.fb-drag
    opacity: .95
    box-shadow: 0 6px 16px rgba(0, 0, 0, .18)
    border-radius: 6px
</style>
